import { Typography, MenuItem, DialogActions, Button, Grid } from '@mui/material';
import { DATE_FORMATS } from '@callmart/types';
import { useTranslation } from 'react-i18next';
import ExportToExcelButton from '../Buttons/ExportToExcelButton';
import { useCustomStyles } from '../../hooks';
import CustomSelect from '../UI/CustomSelect';
import ResponsiveDialog from '../UI/Dialogs/ResponsiveDialog';
import GridContainer from '../Layout/GridContainer';
import dayjs from '@utils/dayjs';

function SelectExportDateRangeDialog({
    open,
    onClose,
    startDateOptions,
    selectedStartDate,
    endDateOptions,
    selectedEndDate,
    onStartDateChange,
    onEndDateChange,
    exportedDataType,
    getDataFromDb,
    getExportData,
    createRowFromExportData,
    exportColumnNames,
    dialogTitle,
    dialogText,
}) {
    const { t } = useTranslation();
    const classes = useCustomStyles();

    const handleClose = () => {
        onClose();
    };

    const handleSelectedStartDateChange = (month) => {
        onStartDateChange(month);
    };

    const handleSelectedEndDateChange = (month) => {
        onEndDateChange(month);
    };

    const getExportFileName = () => {
        const start = dayjs(selectedStartDate).format(DATE_FORMATS.MONTH_YEAR);
        const end = dayjs(selectedEndDate).format(DATE_FORMATS.MONTH_YEAR);

        const fileName = `${exportedDataType}_${start}_${end}.xlsx`;

        return fileName;
    };

    return (
        <ResponsiveDialog
            fullScreen={false}
            title={dialogTitle}
            onClose={handleClose}
            open={open}
            actionButtons={
                <DialogActions sx={{ ...classes.dialogActions, ...classes.marginBottom }}>
                    <Button onClick={handleClose} variant="outlined">
                        {t('action.cancel')}
                    </Button>
                    <ExportToExcelButton
                        columnNames={exportColumnNames}
                        sheetName="Report"
                        getFileName={getExportFileName}
                        wbTitle=""
                        wbSubject="Export Report"
                        createRowFromExportData={createRowFromExportData}
                        getDataFromDb={getDataFromDb}
                        getExportData={getExportData}
                    />
                </DialogActions>
            }
        >
            <GridContainer>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Typography style={{ marginBottom: '30px' }}>{dialogText}</Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={6}>
                    <CustomSelect
                        selectedValue={selectedStartDate}
                        onChange={handleSelectedStartDateChange}
                        label="Start"
                    >
                        {startDateOptions &&
                            startDateOptions.map((month) => (
                                <MenuItem value={month.month} key={month.month}>
                                    {month.monthName}
                                </MenuItem>
                            ))}
                    </CustomSelect>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={6}>
                    <CustomSelect selectedValue={selectedEndDate} onChange={handleSelectedEndDateChange} label="Ende">
                        {endDateOptions &&
                            endDateOptions.map((month) => (
                                <MenuItem value={month.month} key={month.month}>
                                    {month.monthName}
                                </MenuItem>
                            ))}
                    </CustomSelect>
                </Grid>
            </GridContainer>
        </ResponsiveDialog>
    );
}

export default SelectExportDateRangeDialog;
